import styled from 'styled-components';

import { breakpoint } from '../Helper/Breakpoints';

export const styles = {
  TRANSPARENT: 2,
  RED: 3,
};

const buttonStyles = {
  [styles.TRANSPARENT]: {
    borderColor: '#333',
    background: 'transparent',
    color: '#333',
  },
  [styles.RED]: {
    borderColor: '#c73a23',
    background: '#c73a23',
    color: '#fff',
    borderRadius: '5px',
    padding: '7px 20px',
    hoverBorderColor: '#9E301E',
    hoverBackground: '#9E301E',
    letterSpacing: '1px',
    fontWeight: '300',
  },
};

const getButtonStyle = (selectedStyle, animation) => {
  return `
    text-transform: uppercase;
    padding: ${buttonStyles[selectedStyle].padding || '14px 12px'};
    margin: 0 16px 16px 0;
    overflow: hidden;
    display: inline-block;
    position: relative;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    line-height: 1.5;
    font-size: 13px;
    letter-spacing: ${buttonStyles[selectedStyle].letterSpacing || 'unset'};
    font-weight: ${buttonStyles[selectedStyle].fontWeight || '600'};
    text-decoration: none;
    min-width: 130px;
    outline: 0;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    border: 2px solid ${buttonStyles[selectedStyle].borderColor};
    background: ${buttonStyles[selectedStyle].background};
    color: ${buttonStyles[selectedStyle].color};
    border-radius: ${buttonStyles[selectedStyle].borderRadius};

    @media ${breakpoint.md} {
      padding: ${buttonStyles[selectedStyle].padding || '15px 42px'};
    }

    &:hover {
      border: 2px solid ${buttonStyles[selectedStyle].hoverBorderColor};
      background: ${buttonStyles[selectedStyle].hoverBackground};
    }

    ${
      animation &&
      `
      &:hover {
        border: 2px solid ${buttonStyles[selectedStyle].borderColor};
        background: ${buttonStyles[selectedStyle].background};
        color: ${buttonStyles[selectedStyle].color};
      }

      &:hover::before {
        transform: skewX(-30deg) scaleX(1);
      }

      &::before {
        content: '';
        display: block;
        position: absolute;
        left: -22%;
        top: 0;
        background: ${buttonStyles[selectedStyle].borderColor};
        width: 140%;
        height: 100%;
        transform: skewX(-30deg) scaleX(0);
        transition: all 0.8s;
        transform-origin: center left;
        -webkit-mix-blend-mode: difference;
        -moz-mix-blend-mode: difference;
        -o-mix-blend-mode: difference;
        -ms-mix-blend-mode: difference;
        mix-blend-mode: difference;
      }
    `
    }
  `;
};

export const ButtonBar = styled.div`
  margin: 50px 0 16px;
`;

export const ButtonLink = styled.a`
  &:link,
  &:active,
  &:visited {
    ${({ buttonStyle }) => getButtonStyle(typeof buttonStyle === 'undefined' ? styles.TRANSPARENT : buttonStyle)}
  }
`;

export const ButtonHandle = styled.button`
  ${({ buttonStyle }) => getButtonStyle(typeof buttonStyle === 'undefined' ? styles.TRANSPARENT : buttonStyle)}
`;
